export default __webpack_public_path__ + "static/media/feediowhitebackground.6289abc7.png";